import { render, staticRenderFns } from "./booking_charges_report.vue?vue&type=template&id=2f6a6e41"
import script from "./booking_charges_report.vue?vue&type=script&lang=js"
export * from "./booking_charges_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports